import React, { useState, useId } from "react";
import { ReactComponent as CaretDownRed } from "img/arrows/caret-down-red.svg";
import PrimaryButton, { PrimaryButtonProps } from "components/partials/buttons/primary-button";
import SponsorsGridBuilder from 'helpers/builders/sponsors-grid-builder';

export type AccordionItem = {
    headline: string;
    content: string;
    isOpen: boolean;
    buttonLink?: PrimaryButtonProps;
    sponsorsCarouselData?: Queries.SponsorsCarouselBlockFragment;
};

export type AccordionProps = {
    id?: string;
    headline?: string;
    items: AccordionItem[];
};

const Accordion: React.FC<AccordionProps> = ({ id, headline, items }) => {

    // ensure we have a unique id for this accordion, just in case.
    if (!id) {
        id = useId().replaceAll(':', '');
    }

    const [openItems, setOpenItems] = useState(items.map(item => item.isOpen));

    const toggleItem = (index: number) => {
        setOpenItems(prevState => prevState.map((state, i) => i === index ? !state : state));
    };

    return (
        <div className="pattern pattern--accordion">
            <div className="container container--md">
                {headline && <h2>{headline}</h2>}
                <dl className="accordion">
                    {items.map((item, index) => (
                        <React.Fragment key={index}>
                            <dt>
                                <button
                                    type="button"
                                    id={`acc-button-${id}-${index}`}
                                    aria-controls={`acc-section-${id}-${index}`}
                                    aria-expanded={openItems[index]}
                                    onClick={() => toggleItem(index)}
                                >
                                    {item.headline}
                                    <CaretDownRed />
                                </button>
                            </dt>
                            <dd
                                id={`acc-section-${id}-${index}`}
                                aria-labelledby={`acc-button-${id}-${index}`}
                                hidden={!openItems[index]}
                            >
                                <div className="rtecontent" dangerouslySetInnerHTML={{ __html: item.content }} />
                                {item.buttonLink && <PrimaryButton {...item.buttonLink} />}

                                {/* Sponsors */}
                                {item.sponsorsCarouselData &&
                                    <SponsorsGridBuilder sponsorsCarouselData={item.sponsorsCarouselData} />
                                }
                            </dd>
                        </React.Fragment>
                    ))}
                </dl>
            </div>
        </div>
    );
};

export default Accordion;